import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useFieldArray, useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { StepHeader } from "./StepHeader";
import { Form } from "reactstrap";

import MySelect from "../../../MyComp/UI/form/MySelect";

import { toast } from "react-toastify";

import MyButton from "../../../MyComp/UI/form/MyButton";

import moment from "moment";

import MyInput from "../../../MyComp/UI/form/MyInput";
import { createPharmacyAdditopnalStore, createPharmacyProfile } from "../../../api/master/indes";
import { stepOnePharmacyDetails, stepTwoPharmacyDetails } from "../../../api/dropdown";
import useLogout from "../../../hooks/useLogout";

const StepTwoPharmacy = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      storeTypeDD: [],
      countryDD: [{ value: "India", label: "India" }],
      country: { value: "India", label: "India" },
      stateDD: [],
      cityDD: [],
      paymentModeDD: [
        {
          value: "card",
          label: "Card",
        },
        {
          value: "cash",
          label: "Cash",
        },
        {
          value: "net_banking",
          label: "Net Banking",
        },
        {
          value: "upi",
          label: "UPI",
        },
      ],
      deliveryRadiusDD: [
        {
          value: "1",
          label: "1 KM",
        },
        {
          value: "2",
          label: "2 KM",
        },
        {
          value: "3",
          label: "3 KM",
        },
        {
          value: "4",
          label: "4 KM",
        },
        {
          value: "5",
          label: "5 KM",
        },
        {
          value: "6",
          label: "6 KM",
        },
        {
          value: "7",
          label: "7 KM",
        },
        {
          value: "8",
          label: "8 KM",
        },
        {
          value: "9",
          label: "9 KM",
        },
        {
          value: "10",
          label: "10 KM",
        },
      ],

      store_image: null,
      store_img: null,

      pan_image: null,
      pan_img: null,

      drug_img: null,
      drug_image: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      catalog_image: null,
      catalog_img: null,

      fssai_image: null,
      fssai_img: null,

      cheque_image: null,
      cheque_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });


  console.log("");
const logout=useLogout()
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  console.log(location, "location");
  const isLoading = watch("isLoading");

  const onFormSubmit = (data) => {
    const bodyData = {
      pharmacyId: location?.state?.pharmacyId,

      start_time: data.start_time ? moment(data.start_time, "HH:mm").format("hh:mm A") : "",

      end_time: data.end_time ? moment(data.end_time, "HH:mm").format("hh:mm A") : "",

      deleiveryRadius: data.delivery_radius,
      min_order_value: data.min_order_value,
      home_deleivery_charge: data.delivery_charges,

      payment_method: Array.isArray(data.payment_modes) ? data.payment_modes.map((item) => item.value) : [],
    };

    if (mode === "Add"||mode==="Edit") {
      createPharmacyProfile(bodyData)
        .then((res) => {
          if (res.data.status === true) {
            // toast.success(res.data.message);
            navigate("/pharmacy-registration/pharmacy-additional-details", {
              // state: { mode: mode, pharmacyId: res.data.data?.pharmacyId },
              state: { mode: mode, pharmacyId:mode==="Add"? res.data.data?.pharmacyId:location.state.pharmacyId },
            });
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message));
    }
  };

  const startTime = watch("start_time");
    useEffect(() => {
      const body = { pharmacyId: location.state.pharmacyId };
if(mode==="Edit"){
        stepTwoDetails(body);
}
    }, []);
const convertTo24Hour = (time) => {
  if (!time) return "";
  const [t, modifier] = time.split(" ");
  let [hours, minutes] = t.split(":");

  if (modifier === "PM" && hours !== "12") {
    hours = parseInt(hours, 10) + 12;
  }
  if (modifier === "AM" && hours === "12") {
    hours = "00";
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
};

const stepTwoDetails = (body) => {
  stepTwoPharmacyDetails(body)
    .then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;

    
        setValue("start_time", convertTo24Hour(data.start_time));
        setValue("end_time", convertTo24Hour(data.end_time));

       
        setValue("delivery_radius", data.deleiveryRadius || "");
        setValue("min_order_value", data.min_order_value || "");
        setValue("delivery_charges", data.home_deleivery_charge || "");

      
        if (data.payment_method) {
          const paymentModes = data.payment_method.split(",").map((mode) => ({
            value: mode,
            label: mode.replace("_", " ").toUpperCase(),
          }));

          setValue("payment_modes", paymentModes);
        }

        setValue("isLoading", false);
      } 
      else {
        setValue("isLoading", false);
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      setValue("isLoading", false);
      toast.error(err?.response?.data?.message);
    });
};



  return (
    <>
      <Head title={"Pharmacy Registration | Operational Details"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Pharmacy Registration"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={2} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <h5 className="my-3">{"Operational Details"}</h5>
         

         
                <Col md={4}>
                  <div className="form-group my-2">
                    <label className="form-label fw-semibold">Start Time</label>
                    <input
                      type="time"
                      className="form-control"
                      {...register("start_time", {
                        required: "Start time is required",
                      })}
                    />
                    {errors.start_time && <small className="text-danger">{errors.start_time.message}</small>}
                  </div>
                </Col>

                <Col md={4}>
                  {" "}
                  <div className="form-group my-2">
                    <label className="form-label fw-semibold">End Time</label>
                    <input
                      type="time"
                      className="form-control"
                      {...register("end_time", {
                        required: "End time is required",
                        validate: (endTime) => endTime > startTime || "End time must be after start time",
                      })}
                    />
                    {errors.end_time && <small className="text-danger">{errors.end_time.message}</small>}
                  </div>
                </Col>

                <Col md={4}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Delivery Radius"}
                    name={"delivery_radius"}
                    placeholder={"Select delivery radius"}
                    required
                    // options={watch("deliveryRadiusDD")}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Minimum Order Value"}
                    name={"min_order_value"}
                    placeholder={"Enter minimum order value"}
                    required
                    // min={1}
                    // max={3}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Delivery Charges"}
                    name={"delivery_charges"}
                    placeholder={"Enter delivery charges"}
                    required
                    // min={1}
                    // max={2}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md={4}>
                  {/* <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Accepted Payment Modes"}
                    name={"payment_modes"}
                    placeholder={"Select payment modes"}
                    required
                    multi
                    options={watch("paymentModeDD")}
                    disabled={mode == "Approval"}
                  /> */}
                </Col>
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepTwoPharmacy;
